module.exports = __webpack_public_path__ + "static/media/beetzmax-2.43b12f3d.jpg";